import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Link from '@mui/material/Link';
import { MDBox } from '../../MDBox';
import { MDTypography } from '../../MDTypography';
import { menuItem } from './styles';
import { FFTheme } from '../../../assets/theme';
import { MenuItemProps } from '@material-ui/core';

type NotificationItemProps = MenuItemProps & {
  icon: React.ReactNode;
  title: string;
};

export const NotificationItem = ({
  icon,
  title,
  ...rest
}: NotificationItemProps) => {
  return (
    // eslint-disable-next-line
    // @ts-ignore
    <MenuItem {...rest} sx={(theme: FFTheme) => menuItem(theme)}>
      <MDBox
        component={Link}
        py={0.5}
        display="flex"
        alignItems="center"
        lineHeight={1}
      >
        <MDTypography variant="body1" color="secondary" lineHeight={0.75}>
          {icon}
        </MDTypography>
        <MDTypography variant="button" fontWeight="regular" sx={{ ml: 1 }}>
          {title}
        </MDTypography>
      </MDBox>
    </MenuItem>
  );
};

NotificationItem.displayName = 'NotificationItem';
